import Ajax from "Utils/ajax";
 export const leaveMatrix = (data) => Ajax.post('hr/leaveMatrix',data); 
export const odRequest= (data) => Ajax.post('hr/odRequest',data);
export const odRequestList= (data) => Ajax.post('hr/odRequestList',data);
export const removeODRequest= (data) => Ajax.post('hr/removeODRequest',data);
export const getUserNameById = (data) => Ajax.post('hr/getUserNameById',data);
export const changeOnDutyStatus= (data) => Ajax.post('hr/changeOnDutyStatus',data);